import { render, staticRenderFns } from "./Fournisseur.vue?vue&type=template&id=221b4748&scoped=true&"
import script from "./Fournisseur.vue?vue&type=script&lang=js&"
export * from "./Fournisseur.vue?vue&type=script&lang=js&"
import style0 from "./Fournisseur.vue?vue&type=style&index=0&id=221b4748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b4748",
  null
  
)

export default component.exports